import { __assign, __read, __rest, __spread } from "tslib";
import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import ReactMde, { SvgIcon, getDefaultToolbarCommands } from 'react-mde';
import { Icon } from '../Icon/Icon';
export var MarkdownEditor = function (_a) {
    var value = _a.value, wrapperProps = _a.wrapperProps, previewProps = _a.previewProps, _b = _a.selectedTab, selectedTab = _b === void 0 ? 'write' : _b, onTabChange = _a.onTabChange, onChange = _a.onChange, generateMarkdownPreview = _a.generateMarkdownPreview, _c = _a.childProps, childProps = _c === void 0 ? {
        writeButton: {
            tabIndex: -1
        }
    } : _c, rest = __rest(_a, ["value", "wrapperProps", "previewProps", "selectedTab", "onTabChange", "onChange", "generateMarkdownPreview", "childProps"]);
    var _d = __read(useState(selectedTab), 2), _selectedTab = _d[0], _setSelectedTab = _d[1];
    var _onTabChange = onTabChange || (function (tab) { });
    var updateSelectedTab = function (tab) {
        _onTabChange(tab);
        _setSelectedTab(tab);
    };
    var _e = __read(useState(value), 2), _value = _e[0], _setValue = _e[1];
    var _onChange = onChange || (function (markdown) { return console.log(markdown); });
    var updateValue = function (markdown) {
        _setValue(markdown);
        _onChange(markdown);
    };
    var _generateMarkdownPreview = generateMarkdownPreview || (function (markdown) { return Promise.resolve(React.createElement(ReactMarkdown, null, markdown)); });
    return (React.createElement("div", __assign({}, wrapperProps),
        React.createElement(ReactMde, __assign({ value: _value, onChange: updateValue, selectedTab: _selectedTab, onTabChange: updateSelectedTab, childProps: childProps, generateMarkdownPreview: _generateMarkdownPreview, getIcon: function (iconName) {
                if (iconName === 'help') {
                    return React.createElement(Icon, { name: "question" });
                }
                else {
                    return SvgIcon({ icon: iconName });
                }
            }, toolbarCommands: __spread(getDefaultToolbarCommands(), [['help']]), commands: {
                help: {
                    icon: function (getIconFromProvider) { return getIconFromProvider('help'); },
                    execute: function (options) {
                        window.open('https://commonmark.org/help/', '_commonmark');
                        return Promise.resolve();
                    }
                }
            } }, rest))));
};
MarkdownEditor.defaultProps = {
    minEditorHeight: 150,
    maxEditorHeight: 300,
    minPreviewHeight: 150
};
//# sourceMappingURL=MarkdownEditor.js.map